(function () {
  var TTL_DAYS = 7;

  // Allow only these partner codes
  var ALLOW = { "M1": true, "S1": true };

  var KEY_PARTNER = "cs_utm_first";
  var KEY_TS      = "cs_utm_first_ts";
  var KEY_SENT    = "cs_utm_sent";

  function now() { return Date.now(); }
  function ttlMs() { return TTL_DAYS * 24 * 60 * 60 * 1000; }

  function getParam(name) {
    try { return new URL(window.location.href).searchParams.get(name); }
    catch (e) { return null; }
  }

  function isExpired(ts) {
    if (!ts) return true;
    return (now() - Number(ts)) > ttlMs();
  }

  function normalize(code) {
    if (!code) return null;
    code = String(code).trim().toUpperCase();
    return ALLOW[code] ? code : null;
  }

  function setFirstTouch(code) {
    var existing = localStorage.getItem(KEY_PARTNER);
    var ts = localStorage.getItem(KEY_TS);

    // First-touch: don't overwrite within TTL
    if (existing && ts && !isExpired(ts)) return;

    localStorage.setItem(KEY_PARTNER, code);
    localStorage.setItem(KEY_TS, String(now()));
    localStorage.removeItem(KEY_SENT);
  }

  function getFirstTouch() {
    var code = localStorage.getItem(KEY_PARTNER);
    var ts = localStorage.getItem(KEY_TS);

    if (!code || !ts || isExpired(ts)) {
      localStorage.removeItem(KEY_PARTNER);
      localStorage.removeItem(KEY_TS);
      localStorage.removeItem(KEY_SENT);
      return null;
    }

    code = normalize(code);
    if (!code) {
      localStorage.removeItem(KEY_PARTNER);
      localStorage.removeItem(KEY_TS);
      localStorage.removeItem(KEY_SENT);
      return null;
    }

    return code;
  }

  function pushToCartAttributes() {
    var code = getFirstTouch();
    if (!code) return;

    if (localStorage.getItem(KEY_SENT) === code) return;

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          utm_partner: code // Flow reads this
        }
      })
    })
    .then(function () {
      localStorage.setItem(KEY_SENT, code);
    })
    .catch(function () {});
  }

  // Capture: ?utm=M1 / ?utm=S1
  var incoming = normalize(getParam("utm"));
  if (incoming) setFirstTouch(incoming);

  // Push ASAP
  pushToCartAttributes();

  // Safety: Add-to-cart patterns
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form) return;
    var action = (form.getAttribute("action") || "").toLowerCase();
    if (action.indexOf("/cart/add") !== -1) pushToCartAttributes();
  }, true);

  document.addEventListener("click", function () {
    pushToCartAttributes();
  }, { passive: true });

})();